import { createError } from '../utils/background/Utils';

interface ProtobufErrorParams {
    description?: string;
    payload?: object | string | number | boolean | null;
}

const VibeRecognizeRequestError = createError({
    name: 'VibeRecognizeRequestError',
    message: (p: ProtobufErrorParams) => `Error on creating RecognizeRequest: ${p.description}`,
    extra: (p: ProtobufErrorParams) => ({ debugInfo: p.payload || {} }),
    fingerprint: (p: ProtobufErrorParams) => [p.description]
});

const ListenerRequestError = createError({
    name: 'ListenerRequestError',
    message: (p: ProtobufErrorParams) => `Error on creating Request: ${p.description}`,
    extra: (p: ProtobufErrorParams) => ({ debugInfo: p.payload || {} }),
    fingerprint: (p: ProtobufErrorParams) => [p.description]
});

export const Protobuf = { VibeRecognizeRequestError, ListenerRequestError };
